import React from "react"

import styles from "./ChoiceCategoryHeader.module.sass"

const ChoiceCategoryHeader = (props) => {
  return (
    <h4 className={styles.categoryHeader}>
      <span className={styles.categoryText}>{props.children}</span>
      {props.rightContent && (
        <span className={styles.rightContent}>{props.rightContent}</span>
      )}
    </h4>
  )
}

export default ChoiceCategoryHeader
